import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import integrationStore, { IntegrationContext } from "./integrationStore";
import "./msgs/ClientMsgReceiver";
import "./msgs/HeliosMsgReceiver";
import "./msgs/OmnisMsgReceiver";
import "./msgs/LEDActionsMsgReceiver";
import { requestListControllers } from "./msgs/MsgSender";
import { requestListHeliosControllers } from "./msgs/HeliosMsgSender";
import { requestListOmnisControllers } from "./msgs/OmnisMsgSender";
import { requestListServers } from "./msgs/epicMsgSender";
import { requestListLEDAction } from "./msgs/LEDActionsMsgSender";
import { requestListPassports } from "./msgs/powerbiMsgSender";
import { requestListPassports as requestTableauPassports } from "./msgs/tableauMsgSender";
import { requestListPassports as requestListPassportsEpic } from "./msgs/epicMsgSender";
import { requestListPassports as requestListServicenowPassports } from "./msgs/servicenowMsgSender";
import { requestListPassports as requestListGrafanaPassports } from "./msgs/grafanaMsgSender";
import { requestListPassports as requestListSplunkPassports } from "./msgs/splunkMsgSender";
import { requestListPassports as requestListPowerpointPassports } from "./msgs/powerpointMsgSender";
import { requestListPassports as requestListDomoPassports } from "./msgs/domoMsgSender";
import { requestListPassports as requestListSAPPassports } from "./msgs/sapMsgSender";
import { requestListPassports as requestListExcelPassports } from "./msgs/excelMsgSender";
import { requestListConnections as requestListGenetecConnections } from "./msgs/genetecMsgSender";
import { requestListEverbridgeData } from "./msgs/everbridgeMsgSender";
import { requestListConnections as requestListMilestoneConnections } from "./msgs/milestoneMsgSender";

interface IProps {
    children: ReactNode;
}

function IntegrationProvider(props: IProps) {
    useEffect(() => {
        requestListControllers();
        requestListHeliosControllers();
        requestListOmnisControllers();
        requestListServers();
        requestListLEDAction();
        requestListPassports();
        requestTableauPassports();
        requestListPassportsEpic();
        requestListServicenowPassports();
        requestListGrafanaPassports();
        requestListSplunkPassports();
        requestListPowerpointPassports();
        requestListDomoPassports();
        requestListSAPPassports();
        requestListExcelPassports();
        requestListGenetecConnections();
        requestListMilestoneConnections();
        requestListEverbridgeData();
    }, []);

    return (
        <Provider store={integrationStore} context={IntegrationContext}>
            {props.children}
        </Provider>
    );
}

export default IntegrationProvider;
